import { forwardRef, Icon, IconButton } from '@chakra-ui/react'
import { useMemo } from 'react'

import { ExternalLink } from '../Link'

export const ExternalLinkButton = forwardRef(
    /**
     * @typedef {import('@chakra-ui/react').IconButtonProps} IconButtonProps
     * @param {IconButtonProps & { href: string }} props
     * @param {any} ref
     * @returns
     */
    ({ href, ...props }, ref) => {
        return (
            <IconButton
                ref={ref}
                href={href}
                as={href ? ExternalLink : null}
                isDisabled={!href}
                sx={{
                    _disabled: {
                        color: '#90a4ae',
                        cursor: 'not-allowed',
                        pointerEvents: 'none',
                        '& svg path': { fill: 'currentColor' },
                    },
                }}
                {...props}
            />
        )
    }
)

const SFUrlIcon = (props) => {
    return (
        <Icon viewBox="0 0 25 25" fill="#009ddb" {...props}>
            <path
                d="M11.144,7.162
                        c0.652-0.676,1.561-1.103,2.562-1.103c1.336,0,2.493,0.745,3.114,1.848c0.536-0.241,1.134-0.373,1.763-0.373
                        c2.407,0,4.348,1.965,4.348,4.387s-1.949,4.387-4.348,4.387c-0.295,0-0.582-0.031-0.854-0.085
                        c-0.544,0.971-1.584,1.631-2.78,1.631c-0.497,0-0.971-0.116-1.39-0.318c-0.551,1.297-1.84,2.213-3.339,2.213
                        c-1.561,0-2.896-0.986-3.409-2.376c-0.225,0.047-0.458,0.07-0.691,0.07c-1.864,0-3.37-1.522-3.37-3.409
                        c0-1.258,0.676-2.361,1.685-2.951c-0.21-0.474-0.326-1.002-0.326-1.561C4.101,7.372,5.864,5.617,8.023,5.617
                        C9.296,5.617,10.43,6.223,11.144,7.162"
            />
        </Icon>
    )
}

export const FacilitySFURLButton = forwardRef(
    ({ href, size = 'md', ...props }, ref) => {
        const fontSize = useMemo(() => {
            // とりあえず40pxのとき25px
            switch (size) {
                case 'xs':
                    return '16px'
                default:
                    return '25px'
            }
        }, [size])
        return (
            <ExternalLinkButton
                ref={ref}
                href={href}
                aria-label="施設SFURLボタン"
                size={size}
                fontSize={fontSize}
                icon={<SFUrlIcon />}
                {...props}
            />
        )
    }
)

export const OfferSFURLButton = forwardRef(
    ({ href, size = 'md', ...props }, ref) => {
        const fontSize = useMemo(() => {
            // とりあえず40pxのとき25px
            switch (size) {
                case 'xs':
                    return '16px'
                default:
                    return '25px'
            }
        }, [size])
        return (
            <ExternalLinkButton
                ref={ref}
                href={href}
                aria-label="求人SFURLボタン"
                size={size}
                fontSize={fontSize}
                icon={<SFUrlIcon />}
                {...props}
            />
        )
    }
)
